import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";

export const useShowPhoneNumberField = () => {
  const [showPhoneNumberField, setShowPhoneNumberField] = useState(false);

  const router = useRouter();

  const {
    proposalPhoneNumber,
    isPhoneNumberVerified,
    loggedInPhoneNumber
  } = useSelector(({ proposalDataReducer, indexReducer }: any) => ({
    proposalPhoneNumber: proposalDataReducer?.data?.mobileNumber,
    isPhoneNumberVerified: proposalDataReducer?.data?.mobileVerified,
    loggedInPhoneNumber: indexReducer?.mobileNumber,
    proposalSuccess: proposalDataReducer?.isSuccess
  }));

  const { proposal_id } = router.query;

  useEffect(() => {
    if (!proposal_id && loggedInPhoneNumber) {
      setShowPhoneNumberField(false);
    } else if (
      !loggedInPhoneNumber ||
      !proposalPhoneNumber ||
      loggedInPhoneNumber !== proposalPhoneNumber ||
      (proposalPhoneNumber && !isPhoneNumberVerified)
    ) {
      setShowPhoneNumberField(true);
      return;
    } else if (!!proposalPhoneNumber && isPhoneNumberVerified) {
      setShowPhoneNumberField(false);
    }
  }, [proposalPhoneNumber, isPhoneNumberVerified, loggedInPhoneNumber]);

  return { showPhoneNumberField };
};
